import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import {
    Link,
    Redirect
} from 'react-router-dom'
import GlobalHelper from '../../common/GlobalHelper.jsx'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import Integrations from "../../integration/Integrations.jsx"
import FormattedInputField from '../../sharedComponents/formattedInputField.component.jsx'
import { TaxService } from "../../state/tax/service"

const uuidv4 = require('uuid/v4')


class TaxEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            name: '',
            description: '',
            // key is integrationKey and value is array of taxes
            externalTaxesByIntegrationMapping: {},
            // key is integrationKey and value is external tax id
            externalIdsMapping: {},
            components: [],
            formStatus: '',
            deleteButton: '',
            isTaxInclusive: false,
            loading: false,
        }

        this.submitTax = this.submitTax.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleExternalTaxChange = this.handleExternalTaxChange.bind(this)
        this.deleteTax = this.deleteTax.bind(this)
        this.addComponent = this.addComponent.bind(this)
        this.isOnlyTaxOnAccount = this.isOnlyTaxOnAccount.bind(this)
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })

        const tax = this.props.tax
        const externalLinks = tax && tax.attributes.externalLinks ? tax.attributes.externalLinks : []
        let externalIdsMapping = {}
        for (let externalLink of externalLinks) {
            externalIdsMapping[externalLink.attributes.integrationKey] = externalLink.attributes.externalId
        }
        this.setState({
            externalIdsMapping,
        })

        const defaultTax = this.props.defaultTax
        var wasDefaultTax = false
        var inputCheckBox =
            <label className="form-check-label">
                <input className="form-check-input" type="checkbox" name="isDefaultTaxRate" onChange={this.handleFormChange} />
                <FormattedMessage
                    id="tax.form.edit.default_tax_rate_checkbox"
                    defaultMessage="Default tax rate"
                />
            </label>
        if (tax && tax.id == defaultTax.id) {
            wasDefaultTax = true;
            inputCheckBox = <div className="form-check disabled">
                <label className="form-check-label">
                    <input className="form-check-input" type="checkbox" name="isDefaultTaxRate" onChange={this.handleFormChange} disabled checked />
                    <FormattedMessage
                        id="tax.form.edit.default_tax_rate_checkbox"
                        defaultMessage="Default tax rate"
                    />
                </label>
            </div>
        }
   
        if (tax && tax.id) {
            this.isOnlyTaxOnAccount().then(res =>{
                const deleteButton = <ConfirmButton identifier={tax.attributes.name} disabled={res} onClick={this.deleteTax} className="btn btn-danger" >
                    <FormattedMessage
                        id="tax.form.edit.delete_btn"
                        defaultMessage="Delete tax"
                    />
                </ConfirmButton>
                this.setState({
                    id: tax.id,
                    name: tax.attributes.name,
                    description: tax.attributes.description,
                    components: tax.attributes.components.map(c => {
                        return {
                            componentId: c.id,
                            name: c.attributes.name,
                            rate: c.attributes.rate,
                        }
                    }),
                    deleteButton: deleteButton,
                    wasDefaultTax: wasDefaultTax,
                    inputCheckbox: inputCheckBox,
                    isTaxInclusive: tax.attributes.isTaxInclusive,
                })
            })
        } else {
            this.addComponent()
        }

        AppContext.getApiClient().get('/external-taxes').then(res => {
            this.setState({
                loading: false,
            })

            const externalTaxesByIntegrationMapping = {}
            for (let tax of res.data) {
                if (!externalTaxesByIntegrationMapping[tax.attributes.integrationKey]) {
                    externalTaxesByIntegrationMapping[tax.attributes.integrationKey] = []
                }
                externalTaxesByIntegrationMapping[tax.attributes.integrationKey].push(tax)
            }

            this.setState({
                externalTaxesByIntegrationMapping,
            })
        })
    }

    addComponent(event) {
        event?.preventDefault()
        const components = this.state.components
        components.push({
            componentId: uuidv4(),
            name: '',
            rate: '',
        })
        this.setState({
            components: components,
        })
    }

    deleteComponent(componentId) {
        return function (event) {
            event.preventDefault()
            this.setState({
                components: this.state.components.filter(c => c.componentId !== componentId),
            })
        }.bind(this)
    }

    deleteTax() {
        const tax = this.props.tax
        const defaultTax = this.props.defaultTax
        let formStatus = ""
        const alertDiv = (message) => (
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                {message}
            </div>
        )

        if (tax.id === defaultTax.id) {
            const errorMessage = 
                    <FormattedMessage
                        id="tax.form.edit.error_message_default_tax"
                        defaultMessage="Cannot delete the default tax. Please select another tax rate as the default before proceeding with the deletion."
                    />
            
            this.setState({ formStatus: alertDiv(errorMessage) })
        } else {
            TaxService.delete(tax.id).then((response) => {
                if (response.error && response.error.type === "tax_assigned_to_contact") {
                    formStatus = alertDiv(
                            <FormattedMessage
                                id="tax.form.edit.error_message_tax_assigned_to_contact"
                                defaultMessage="One or more contacts have this tax rate set as their default. Please update these contacts to ensure they don't use this rate before proceeding with the deletion."
                            />)
                } else if (response.error) {
                    formStatus = alertDiv(
                        <FormattedMessage
                            id="tax.form.edit.error_message"
                            defaultMessage="Error! {errorMessage}"
                            values={{ errorMessage: response.error.message }}
                        />)

                } else {
                    formStatus = <Redirect
                        to={{
                            pathname: '/settings'
                        }}
                    />
                }
                this.setState({ formStatus: formStatus })
            })
        }

        event.preventDefault()
    }

    saveTax() {
        const tax = this.props.tax
        if (tax && tax.id) {
            let updates = {}
            const allowedTaxFields = [
                "name",
                "description",
                "components",
                "externalIdsMapping",
                "isTaxInclusive",
            ]
            for (let i = 0; i < allowedTaxFields.length; i++) {
                let field = allowedTaxFields[i]
                if (tax.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }

            if (this.state["isDefaultTaxRate"]) {
                AppContext.getApiClient().put('/taxes/default/' + tax.id, {})
            }

            return AppContext.getApiClient().patch('/taxes/' + tax.id, updates)
        } else {
            return AppContext.getApiClient().post('/taxes', {
                "name": this.state.name,
                "description": this.state.description,
                "components": this.state.components,
                "externalIdsMapping": this.state.externalIdsMapping,
                "isTaxInclusive": this.state.isTaxInclusive,
            }).then(res => {
                if (this.state["isDefaultTaxRate"]) {
                    return AppContext.getApiClient().put('/taxes/default/' + res.json.id, {})
                }
                return res
            });
        }
    }

    submitTax(event) {
        this.saveTax().then((response) => {
            let formStatus = ''
            if (response.error) {
                formStatus = <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <FormattedMessage
                        id="tax.form.edit.error_message"
                        defaultMessage="Error! {errorMessage}"
                        values={{ errorMessage: response.error.message }}
                    />
                </div>

            } else {
                formStatus = <Redirect
                    to={{
                        pathname: '/settings/taxes/listing'
                    }}
                />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleExternalTaxChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name

        let externalIdsMapping = Object.assign({}, this.state.externalIdsMapping)
        externalIdsMapping[name] = value

        this.setState({
            externalIdsMapping,
        });
    }


    handleComponentFormChange(componentId) {
        return function (event) {
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name
            this.setState({
                components: this.state.components.map(c => {
                    if (c.componentId === componentId) {
                        c[name] = value
                    }
                    return c
                })
            })
        }.bind(this)

    }

    isOnlyTaxOnAccount(){
        return TaxService.get().then(res => {
            if (res && res.data) {
                const totalTaxes = res.data.length
                return totalTaxes === 1
            }
            return false
        })
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }

        const messages = defineMessages({
            "tax.form.edit.save_btn": {
                id: 'tax.form.edit.save_btn',
                defaultMessage: 'Save',
            },
            "tax_description_placeholder": {
                id: 'tax.form.edit.description_placeholder',
                defaultMessage: 'Describe the tax in a few words',
            },
            "tax.form.edit.none_label": {
                id: 'tax.form.edit.none_label',
                defaultMessage: 'None',
            },
        })
        return (
            <form onSubmit={this.submitTax}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="taxName">
                                <FormattedMessage
                                    id="tax.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10">
                                <input name="name" value={this.state.name} onChange={this.handleFormChange} id="taxName" type="text" className="form-control" />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="tax.form.edit.name_description"
                                        defaultMessage="Name of the tax"
                                    />
                                </small>
                            </div>
                        </div>
                        {
                            Object.keys(this.state.externalTaxesByIntegrationMapping).map((integrationKey) => {
                                return this.state.externalTaxesByIntegrationMapping[integrationKey].length > 0 ?
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label text-align-right" htmlFor={'externalId-' + integrationKey}>
                                            <FormattedMessage
                                                id="tax.form.edit.integration_external_id_label"
                                                defaultMessage="External Tax for {integrationName}"
                                                values={{
                                                    integrationName: Integrations.getIntegrationLogoImage(integrationKey, '75')
                                                }}
                                            />
                                        </label>

                                        <div className="col-10">
                                            <select
                                                id={integrationKey}
                                                name={integrationKey}
                                                className={'form-control'}
                                                value={this.state.externalIdsMapping[integrationKey]}
                                                onChange={this.handleExternalTaxChange}
                                            >
                                                <option value={''}>
                                                    {this.props.intl.formatMessage(messages['tax.form.edit.none_label'])}
                                                </option>

                                                {
                                                    this.state.externalTaxesByIntegrationMapping[integrationKey].map(t => {
                                                        let tax = t.attributes
                                                        let components = tax.components
                                                            .filter(c => c.rate != "")
                                                            .map(({ name: name, rate: rate }) =>
                                                                parseFloat(rate).toString() + "%"
                                                            )

                                                        return <option id={t.id} key={t.id} value={t.id}>
                                                            {components.length > 1 ?
                                                                `${tax.name} (${components.join(' + ')} = ${tax.totalRate}%)` :
                                                                `${tax.name} (${tax.totalRate}%)`
                                                            }
                                                        </option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : null
                            })
                        }
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="taxDescription">
                                <FormattedMessage
                                    id="tax.form.edit.description_label"
                                    defaultMessage="Description"
                                />
                            </label>
                            <div className="col-10">
                                <input name="description" value={this.state.description} onChange={this.handleFormChange} id="taxDescription" type="text" className="form-control" placeholder={this.props.intl.formatMessage(messages["tax_description_placeholder"])} />

                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="tax.form.edit.description_description"
                                        defaultMessage="Description of the tax"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="taxRate">
                                <FormattedMessage
                                    id="tax.form.edit.components_label"
                                    defaultMessage="Tax rates"
                                />
                            </label>
                            <div className="col-10">
                                {this.state.components.map(c => {
                                    return <div className="row border-bottom mb-3" key={c.componentId}>
                                        <div className="form-group mb-2 col-5">
                                            <input name="name"
                                                value={c.name}
                                                onChange={this.handleComponentFormChange(c.componentId)}
                                                id={'name_' + c.componentId}
                                                type="text"
                                                className="form-control"
                                            />
                                            <small className="form-text text-muted">
                                                <FormattedMessage
                                                    id="tax.form.edit.components.name_description"
                                                    defaultMessage="Name of the tax component"
                                                />
                                            </small>
                                        </div>
                                        <div className="form-group mb-2 col-5">
                                            <FormattedInputField name="rate"
                                                id={'rate_' + c.componentId}
                                                type="text"
                                                className="form-control"
                                                placeholder={GlobalHelper.applyLocaleDecimal("9.975", AppContext.getLocale().getLanguage())}
                                                valueType="money"
                                                value={c.rate}
                                                onValueChange={(newValue) => {
                                                    this.setState({
                                                        components: this.state.components.map(co => {
                                                            if (co.componentId === c.componentId) {
                                                                co["rate"] = newValue
                                                            }
                                                            return co
                                                        })
                                                    })
                                                }}
                                            />
                                            <small className="form-text text-muted">
                                                <FormattedMessage
                                                    id="tax.form.edit.components.rate_description"
                                                    defaultMessage="Tax rate"
                                                />
                                            </small>
                                        </div>
                                        <div className="form-group mb-2 col-2">
                                            <button className="btn btn-sm btn-danger" onClick={this.deleteComponent(c.componentId)}>
                                                <FormattedMessage
                                                    id="tax.form.edit.components.delete_component_btn"
                                                    defaultMessage="Remove"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                })}
                                <div className="row">
                                    <div className="col-12">
                                        <button className="btn btn-sm btn-primary" onClick={this.addComponent}>
                                            <FormattedMessage
                                                id="tax.form.edit.components.add_component_btn"
                                                defaultMessage="Add component"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="form-check">
                                {this.state.inputCheckbox}
                            </div>
                        </div>

                    </div>

                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton} 
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/settings" className="btn btn-light">
                                    <FormattedMessage
                                        id="tax.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['tax.form.edit.save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(TaxEditForm)


// WEBPACK FOOTER //
// ./src/settings/taxes/taxEditForm.component.jsx